import { useTranslation } from "react-i18next";
import { TabPanel, TabPanels, Tabs } from "@caspeco/casper-ui-library.components.tabs";
import { useMenuAPI, useMenuStore } from "store/menuStore";
import SectionTabs from "components/section-tabs/SectionTabs";
import NotFound from "components/not-found/NotFound";
import { useSectionTabIndex } from "../../hooks/useCurrentMenuSectionTab";
import MenuSection from "../menu-section/MenuSection";

interface IMenuSectionTabs {
	onClickArticle: (articleId: string, articleName: string) => void;
}

export function MenuSectionTabs({ onClickArticle }: IMenuSectionTabs) {
	const { t } = useTranslation();
	const tabIndex = useSectionTabIndex();
	const { menu } = useMenuStore();
	const { setSelectedSection } = useMenuAPI();

	const onChange = (newIndex: number) => {
		if (!menu) return;
		setSelectedSection(menu.sections[newIndex]);
	};

	if (!menu?.sections.length) {
		return <NotFound description={t("menu_section_articles_empty_title")} />;
	}

	return (
		<Tabs isLazy onChange={onChange} index={tabIndex}>
			<SectionTabs />
			<TabPanels>
				{menu?.sections.map((section) => (
					<TabPanel key={section.id}>
						<MenuSection section={section} onClickArticle={onClickArticle} />
					</TabPanel>
				))}
			</TabPanels>
		</Tabs>
	);
}
